<template>
	<div class="grid-100 grid-parent" :class="`grid-100 grid-parent ${this.classes}`">
		<div class="grid-container">
			<div class="about-horizontal-wrapper layer1">
				<div class="about-horizontal-list" ref="slider">
					<div v-for="(item, index) in items" :key="index" class="about-item" :class="{ small: (item.small_image == '1')}">
						<div class="about-img" :style="{ backgroundImage: 'url(' + item.background_image.guid + ')' }"></div>
						<div class="about-copy" v-bind:class="{ white: (item.text_color == 'white')}">
							<h4 class="title" v-html="item.title.rendered"></h4>
							<p v-html="item.content.rendered"></p>
						</div>
						<div class="line-info">
							<span class="year" v-bind:class="{ white: (item.text_color == 'white'), black: (item.text_color == 'black')}">{{item.about_date}}</span>
							<a class="cta" v-if="item.link_text"><span>{{item.link_text}}</span></a>
						</div>
					</div>
				</div>
			</div>
			<div class="arrows-bar grid-100 grid-parent">
				<img v-on:click="timelineLeft()" class="arrow-left" src="../assets/images/arrow-left.png" />
				<img v-on:click="timelineRight()" class="arrow-right" src="../assets/images/arrow-right.png" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'carousel',
	props: {
		items: {
			type: Array,
			required: true
		},
		classes: {
			type: String,
			required: false
		}
	},
	methods: {
		timelineRight() {
            const slider = this.$refs.slider;
            const mobile = window.innerWidth < 970;
            const scrollDistance = mobile ? slider.offsetWidth : 970 / 2;

            if (!mobile && slider.scrollLeft === 0) {
                slider.scrollLeft = slider.offsetWidth / 2;
            } else {
                slider.scrollLeft += scrollDistance;
            }
        },
        timelineLeft() {
            const slider = this.$refs.slider;
            const mobile = window.innerWidth < 970;
            const scrollDistance = mobile ? slider.offsetWidth : 970;

            slider.scrollLeft -= scrollDistance;
        }
	}
};
</script>


// WEBPACK FOOTER //
// Carousel.vue?24b003e6